import gql from 'graphql-tag';

export default gql`
  mutation updateIntegration($integration: IntegrationInput!) {
    updateIntegration(integration: $integration) {
      _id
    }
  }
`;
